// Carousel embedded images
export const CAROUSEL1_BEFORE = '/img/carousel-carousel1_before.webp';
export const CAROUSEL1_AFTER = '/img/carousel-carousel1_after.webp';
export const CAROUSEL2_BEFORE = '/img/carousel-carousel2_before.webp';
export const CAROUSEL2_AFTER = '/img/carousel-carousel2_after.webp';
export const CAROUSEL3_BEFORE = '/img/carousel-carousel3_before.webp';
export const CAROUSEL3_AFTER = '/img/carousel-carousel3_after.webp';
export const CAROUSEL4_BEFORE = '/img/carousel-carousel4_before.webp';
export const CAROUSEL4_AFTER = '/img/carousel-carousel4_after.webp';